<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <ul class="deta_list">
      <li>
        <span>【预约院区】</span>
        <span>{{ hspName }}</span>
      </li>
      <li>
        <span>【预约科室】</span>
        <span>{{ doctorInfo.DeptName }}</span>
      </li>
      <li>
        <span>【预约医生】</span>
        <span>{{ doctorInfo.DoctorName }}</span>
      </li>
      <li>
        <span>【预约费用】</span>
        <span style="color: #CD3333;">￥{{ doctorInfo.Fee }}</span>
      </li>
      <li>
        <span>【预约时间】</span>
        <span>{{ clinicDate }} {{ timeData2.today }} {{ timeData2.wu }}</span>
      </li>
      <li>
        <span>【预约时间段】</span>
        <span>{{ timeSlotDisplay }}</span>
      </li>
      <li>
        <span>【当前支付方式】</span>
        <span style="color: blue">{{
          radio === "0" ? "自费支付" : "医保支付"
        }}</span>
      </li>
      <li class="mode">
        <el-radio v-model="radio" label="0">自费</el-radio>
        <el-radio v-model="radio" label="1">医保</el-radio>
      </li>
    </ul>
    <div @click="order" class="yygh">
      <van-button type="info">预约挂号</van-button>
    </div>
  </div>
</template>

<script>
import {
  LockRegOrder,
  pay,
  payRegOrder,
  CancelLockRegOrder
} from "@/request/api.js";
import { post } from "@/request/http.js";
import { Dialog } from "vant";
import lastpage from "@/components/lastpage/lastpage.vue";

const USER_ID = "7148";
const REG_FEE_URL = "http://183.234.14.131:8888/api/His/GetRegFee";

function safeJson(raw, fallback) {
  if (raw == null || raw === "") return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

export default {
  components: {
    lastpage
  },
  data() {
    return {
      clinicDate: "",
      card: {},
      doctorInfo: {},
      timeData: {},
      timeData2: {},
      hspName: sessionStorage.getItem("hspName"),
      refRecordData: {},
      radio: "0",
      isLoading: false
    };
  },
  computed: {
    timeSlotDisplay() {
      const desc = (this.timeData && this.timeData.TimeDesc) || "";
      const parts = desc.split(" ");
      return parts[1] ? parts[1].replace(/-/g, "~") : "";
    },
    /** 当日挂号 regType=0，预约 regType=1 */
    regType() {
      return this.clinicDate === this.$moment().format("YYYY-MM-DD") ? 0 : 1;
    }
  },
  created() {
    const rawDate = sessionStorage.getItem("clinicDate") || "";
    this.clinicDate = rawDate
      ? this.$moment(rawDate.replace(/-/g, "/")).format("YYYY-MM-DD")
      : this.$moment().format("YYYY-MM-DD");

    this.card = safeJson(sessionStorage.getItem("card"), {});
    this.doctorInfo = safeJson(sessionStorage.getItem("doctorInfo"), {});
    this.timeData = safeJson(sessionStorage.getItem("timeData"), {});
    this.timeData2 = safeJson(sessionStorage.getItem("timeData2"), {});
    this.refRecordData = safeJson(sessionStorage.getItem("refRecordData"), {});

    if (this.refRecordData.resultData) {
      this.doctorInfo.Fee = 0;
    } else {
      this.getRegFee();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path === "/countDown") {
        vm.$router.push("/mySubscribe");
      } else if (from.path === "/mySubscribe") {
        vm.$router.go(-1);
      }
    });
  },
  methods: {
    async getRegFee() {
      try {
        const data = await post(REG_FEE_URL, {
          WorkId: this.doctorInfo.WorkId,
          CardNo: this.card.cardno2
        });
        const res = data.data;
        if (res.StatusCode === 200) {
          res.Data = JSON.parse(res.Data);
          this.doctorInfo.Fee = res.Data.ResultData;
        }
      } catch (e) {
        // 保留 session 中的挂号费或已有 Fee
      }
    },
    buildLockOrderPayload() {
      return {
        deptname: this.hspName,
        doctor: this.doctorInfo.DoctorName,
        parentdeptname: this.doctorInfo.DeptName,
        patientname: this.card.patientname,
        hspcode: sessionStorage.getItem("hspCode"),
        lockRegOrderPo: {
          clinicDate: this.clinicDate,
          deptID: this.doctorInfo.DeptID,
          doctorId: this.doctorInfo.DoctorId,
          patientID: this.card.patientId,
          regType: this.regType,
          timeId: this.timeData.TimeId,
          cardNo: this.card.cardno,
          idCardNo: this.card.idcardno,
          regTypeId: this.timeData.RegTypeId,
          isYb: this.radio !== "0"
        },
        openid: this.card.openid,
        visitingtime: this.timeData.TimeDesc,
        regFee: Number(this.doctorInfo.Fee)
      };
    },
    async order() {
      if (this.isLoading) return;
      try {
        this.isLoading = true;
        const map = this.buildLockOrderPayload();
        const res = await LockRegOrder(map);
        if (res.data.message === "操作成功") {
          const obj = res.data.obj || {};
          if (this.radio === "1" && obj.fee == obj.regAmount) {
            Dialog.alert({ message: "查无医保，请自费支付" }).then(() => {
              this.cancle(res);
            });
          } else {
            Dialog.alert({ message: "预约成功" }).then(() => {
              this.pay(res);
            });
          }
        } else {
          this.Toast.fail(`预约失败，${res.data.message}`);
        }
      } catch (error) {
        this.Toast(JSON.stringify(error));
      } finally {
        this.isLoading = false;
      }
    },

    async pay(res) {
      const obj = (res.data && res.data.obj) || {};
      if (this.doctorInfo.Fee === 0) {
        const confirmPayMap = {
          bankTranInfo: "",
          clinicDate: this.clinicDate,
          deptID: this.doctorInfo.DeptID,
          doctorId: this.doctorInfo.DoctorId,
          fee: 0,
          lockID: obj.lockid,
          orderId: obj.lockid,
          patientID: this.card.patientId,
          payTag: 2,
          policyInfo: "",
          regType: this.regType,
          selfTranNo: "",
          timeId: this.timeData.TimeId,
          userId: USER_ID
        };
        const cpres = await payRegOrder(confirmPayMap);
        if (cpres.data.message === "操作成功") {
          this.$router.push("/mySubscribe");
        }
        return;
      }

      sessionStorage.setItem("tradeid", obj.tradeid);
      sessionStorage.setItem("order", JSON.stringify(obj));
      const feeSelf = this.radio === "0";
      const paymap = {
        flag: 1,
        payTypeId: 1,
        orderDate: obj.regtime.slice(0, 10),
        orderTime: this.$moment().format("HH:mm:ss"),
        orderTimeoutDate: "",
        orderNo: obj.lockid,
        currencyCode: 156,
        orderAmount: feeSelf ? obj.fee : obj.regAmount,
        fee: feeSelf ? obj.fee : obj.regAmount,
        payInDepositOrderPo: {},
        payOpChargePo: {},
        subsidAmount: "",
        expireDate: "",
        accountNo: "",
        openID: obj.openid,
        orderDesc: "医院公众号预约挂号",
        receiverAddress: "",
        buyIp: ""
      };
      const rs = await pay(paymap);
      this.invokeWechatPay(rs);
    },

    /** 调起微信 JSAPI 支付；修正原回调中 cancel 分支误写在 ok 内的问题 */
    invokeWechatPay(rs) {
      const payParams = {
        appId: rs.data.obj.sub_appId,
        timeStamp: rs.data.obj.timeStamp,
        nonceStr: rs.data.obj.nonceStr,
        signType: rs.data.obj.signType,
        paySign: rs.data.obj.paySign,
        package: rs.data.obj.package
      };
      const onResult = payRes => {
        const msg = (payRes && payRes.err_msg) || "";
        if (msg === "get_brand_wcpay_request:ok") {
          this.Toast.success("支付成功,即将返回预约记录页面");
          setTimeout(() => this.$router.push("/mySubscribe"), 1500);
        } else {
          this.$router.push("/mySubscribe");
        }
      };
      const ready = () => {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          payParams,
          onResult
        );
      };
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", ready, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", ready);
          document.attachEvent("onWeixinJSBridgeReady", ready);
        }
      } else {
        ready();
      }
    },

    async cancle(res) {
      const obj = (res.data && res.data.obj) || {};
      const res2 = await CancelLockRegOrder({
        lockID: obj.lockid,
        userId: USER_ID
      });
      if (res2.data.message === "操作成功") {
        this.radio = "0";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .deta_list {
    // margin-top: 10px;
    padding: 30px 28px 14px;
    background: #fff;
    font-size: 15px;
    display: flex;
    flex-flow: column nowrap;
    > li {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      margin-bottom: 14px;
      > span:nth-child(1) {
        font-weight: bold;
      }
      > span:nth-child(2) {
        color: #8b8b8b;
      }
    }
    .mode {
      margin-top: 14px;
      font-weight: bold;
      font-size: 16px;
      justify-content: space-around;
      > span:nth-child(1) {
        color: black;
        letter-spacing: 1px;
      }
      > span {
        position: relative;
        input {
          position: relative;
          top: 3px;
          width: 16px;
          height: 16px;
          margin-right: 1px;
          accent-color: rgb(55, 118, 255);
        }
      }
    }
  }
  /deep/ .yygh {
    position: absolute;
    width: 355px;
    bottom: 40px;
    text-align: center;
    margin: 0px 10px;
    background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button {
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      letter-spacing: 1px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/AppointmentDetails.vue